import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import intl from 'react-intl-universal';

import './CancelButton.css';

class CancelButton extends Component {
    render() {
        return (
            <li onClick={this.props.cancelOnClick} className="CancelButton">
                <div className="icon">
                    <FontAwesomeIcon icon={ faTimes } />
                </div>
                <div className="text">
                    {this.props.icon.text}
                </div>
            </li>
        );
    }
}

export default CancelButton;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/DrawerContainer/components/CancelButton/index.js